globalThis.user_signup = function(){
    //path to the check username api
    var username_api_path = '/users/1/check_username';
    let place_id = 1000;
    let ok = false;
    let username_valid = false;
    let email_valid = false;
    let password_valid = false;

    const check = () => {
        ok = (username_valid && password_valid && email_valid)
        toggle_button("#submit", ok);
    }
    const setup_hear_about_us = () => {
        const hear_about_us_other = $("#user_profile_attributes_hear_about_us_other");
        const hear_about_us = $('#user_profile_attributes_hear_about_us');
        hear_about_us.on('change', function(e){
            const val = e.target.value;
            if (val === "Other") {
                hear_about_us_other.show();
            } else {
                hear_about_us_other.hide();
            }
        });
        if (hear_about_us.value === "Other") {
            hear_about_us_other.show();
        } else {
            hear_about_us_other.hide();
        }
    }
    const toggle_button = (sel, enabled) => {
        const element = document.querySelector(sel);
        if (element) {
            element.disabled = !enabled;
        } else {
            console.log(`couldn't fine ${sel}, returned: ${element}`);
        }
    }
    //this function sets up validation for a username field, given a selector
    function add_user_name_validation(selector, saveButton){
        //when changing focus from the name field, check for username validity
        $(selector).on('blur', function(){
            var value = $(this).val();

            //first check if length is 4..50
            if(value.length >= 4 && value.length <=50){
                //then check if username is valid (alphanumerics and start with letter)
                username_valid = ldc_lui.valid_username_regex.test(value.toLowerCase());
                debugger;
                if(username_valid){
                    //then check if the username is already taken in a JSON call
                    $.get(username_api_path, {username: value}, function(data) {
                        if(data.user_exists){
                            username_valid = false;
                            $('#name-alert').html('Username already taken');
                        }else{
                            username_valid = true;
                            $('#name-alert').html('');
                        }
                    }, 'json');
                }else{
                    username_valid = false;
                    $('#name-alert').html('Username must contain only letters, numbers, hyphens, underscores, or periods.');
                }
            }else{
                username_valid = false;
                $('#name-alert').html('Username can only be 4-50 characters long');
            }
            check();
        });
    };

    //sets up the validation for password/password confirmation
    function add_password_validation(password_selector, confirmation_selector, saveButton){
        //listener on the password to ensure the length is within our range
        $(password_selector).on('blur', function(){
            password_valid = $(this).val().length >= 6;
            $('#password-alert').html(password_valid ? '' : 'Password must have length >= 8');
            check();
        });

        //listener on the password/password confirmation to ensure their values match
        $(password_selector + ', ' + confirmation_selector).on('blur', function(){
            var password = $(password_selector).val();
            var password_confirmation = $(confirmation_selector).val();
            var passwords_match = password === password_confirmation;

            $('#password_confirm-alert').html(passwords_match ? '' : 'Password and confirmation must match');
            password_valid = passwords_match;
            //check to make sure we aren't overriding the previous listener
            if($('#password-alert').html().length === 0) {
                check();

            }
        });
    };

    //sets up validation for the user's email address
    function add_email_validation(selector, saveButton){
        //listener to check for email address validity when focus is lost
        $(selector).on('blur', function(){
            email_valid = ldc_lui.valid_email_regex.test($(this).val());
            $('#email-alert').html(email_valid ? '' : 'Invalid Email Address');
            check();
        });
    };

    //sets up validation for year (optional)
    function add_year_validation(selector, saveButton){
        //listener to check for year validity when focus is lost
        $(selector).on('blur', function(){
            var curr_year = (new Date().getFullYear());
            var year = $(this).val()
            var year_valid = /\d{4}/.test(year) && year >= 1890 && year <= curr_year;
            if(year == '')
                year_valid = true;
            $(this).siblings('[id$="-alert"]').html(year_valid ? '' : `Year must be a 4-digit number greater than 1890 and no more than ${curr_year}`);
            toggle_button(saveButton, year_valid);
        });
    };
    console.log("setup");
    return{
        //this function is called when initializing the new view (the user signup page)
        init: function(){
            console.log("init, innnit?");
            // $('#submit').prop('disabled', true);

            //listener to check for email address validity when focus is lost
            add_email_validation('#user_email', '#submit');

            //when changing focus from the name field, check for username validity
            add_user_name_validation('#user_name', '#submit');

            //add password/password confirmation validation
            add_password_validation('#user_password', '#user_password_confirmation', '#submit');
            add_year_validation('.validate_year', '#submit');
            $('form').on('keypress', e => {
                if (e.keyCode == 13) {
                    return false;
                }
            });

            $('body').on('click', '.add_fields', function(e){
                console.log('add_fields clicked');
                e.preventDefault();
                const regexp = new RegExp($(this).data('id'), 'g');
                $(this).before($(this).data('fields').replace(regexp, ''));
                add_year_validation('.validate_year', '#submit');
                return(false);
            });


            check();

            setup_hear_about_us();

        }
    }
}();
